export const fonts = {
    defaultFontFamily: "Arimo",
    secondaryFontFamily: "'Secular One', sans-serif"
}